import $ from "jquery"
import OverlayTips from "../OverlayTips"
import PageOverlayTipsManager from '../PageOverlayTipsManager'
import {connect} from '../../redux/utils'
import {isTWSEnabled} from '../../features/selectors'

class TaskManagementPageOverlayTipsManager extends PageOverlayTipsManager {
    constructor() {
        super()

        this.state = {
            isTWSEnabled: false,
        }

        this.onStatePropertyChanged('isTWSEnabled', () => {
            this.refreshDynamicTips()
        })
    }

    addBaseTips() {
        super.addBaseTips()

        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add(function() { return $(".collapseAllButton") }, {
            messageKey: "task.list.tips.collapse_all",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: -10
        });

        this.add(function() { return $(".tasksTable .headerRowTable .status .headerCellWrapper") }, {
            messageKey: "task.list.tips.status_filter",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -40,
            offsetY: 5
        });

        this.add(function() { return $(".taskManagementHeaderPanel .searchField") }, {
            messageKey: "task.list.tips.name_filter",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: 5
        });

        this.add(function() { return $(".taskRow").eqOrLast(4).find(".checkbox") }, {
            messageKey: "task.list.tips.select_task",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -15,
            offsetY: 15
        });

        this.add(() =>  this.state.isTWSEnabled ? $(".viewModeSelector") : $(), {
            messageKey: "task.list.tips.view_mode",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -52,
            offsetY: 0
        })
    }
}

export default connect(
    state => ({
        isTWSEnabled: isTWSEnabled(state),
    })
)(TaskManagementPageOverlayTipsManager)



// WEBPACK FOOTER //
// ./web/js/tips/managers/TaskManagementPageOverlayTipsManager.js